import React, { useState } from "react";
import { Star, MapPin, ChevronRight, Info } from "lucide-react";
import JsonData1 from "../../data/ActualData.json";

import ReactPaginate from "react-paginate";
import ClearIcon from "@mui/icons-material/Clear";
import { Button } from "@mui/material";
import { FaRedo } from "react-icons/fa";
import SingleBarChart from "../../chats/SingleBarChart";
import DrawerPage from "./DrawerPage";
import { Link } from "react-router-dom";
import PlotlyGrapgh from "../../chats/PlotlyGrapgh";
import RadialBarChart from "../../chats/RadialBarChart";

const CircularProgress = ({ percentage }) => {
  const circumference = 2 * Math.PI * 20;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;



  return (
    <div className="relative inline-flex items-center justify-center">
      <svg className="transform -rotate-90 w-16 h-16">
        <circle
          className="text-gray-200"
          strokeWidth="4"
          stroke="currentColor"
          fill="transparent"
          r="30"
          cx="32"
          cy="32"
        />
        <circle
          className="text-green-600"
          strokeWidth="4"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          stroke="currentColor"
          fill="transparent"
          r="30"
          cx="32"
          cy="32"
        />
      </svg>
      <span className="absolute text-sm font-semibold">{percentage}%</span>
    </div>
  );
};

const BarChart = ({ percentage }) => {
  return (
    <div className="relative w-full h-6 bg-gray-200 rounded-full">
      <div
        className="absolute top-0 left-0 h-full bg-green-600 rounded-full"
        style={{ width: `${percentage}%` }}
      ></div>
      <span className="absolute left-1/2 transform -translate-x-1/2 top-1/2 text-xs font-semibold text-white">
        {percentage}%
      </span>
    </div>
  );
};

export const Listing = ({ dataItem }) => {
  console.log(dataItem);
  const [data, setData] = useState(dataItem);
  const [query, setQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPagelimit, setPageLimit] = useState(10);
  const [segmentType, setSegment] = useState("");
  const filter_by_role = [...new Set(data.map((item) => item.Status))];

  let filteredData = [];
  const search_parameters = ["Particulars"];

  filteredData = data.filter((obj) => {
    return obj;
  });

  function search(filteredData) {
    return filteredData.filter(
      (item) =>
        item.Status.includes(segmentType) &&
        search_parameters.some((parameter) =>
          item[parameter].toString().toLowerCase().includes(query.toLowerCase())
        )
    );
  }

  const currentData = search(filteredData).slice(
    (currentPage - 1) * currentPagelimit,
    (currentPage - 1) * currentPagelimit + currentPagelimit
  );

  const pageCount = Math.ceil(search(filteredData).length / currentPagelimit);

  const handelepageclick = (data) => {
    setCurrentPage(data.selected + 1);
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const reset = () => {
    setCurrentPage(1);
    setQuery("");
    setSegment("");
  };
  const urlParams = new URLSearchParams(window.location.search);
  const name = urlParams.get("name");
  const details = urlParams.get("details");
  const node = urlParams.get("node");


  const totalMargin = data && data
  .reduce((sum, item) => sum + parseFloat(item.TotalValue), 0);
  console.log("totalMargin")
  console.log(totalMargin/0 * 100)

  return (
    <div style={{ padding: "1rem", zoom: ".9" }}>
      <div
        style={{
          display: "flex",
          paddingBottom: "0rem",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gridGap: "10px",
        }}
      >
        <div className="search-input-cont">
          <input
            type="text"
            className="table-search-input"
            placeholder="Search by Name"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <div className="search-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <path
                d="M18.0835 16.3331H17.1619L16.8352 16.0181C17.5643 15.171 18.0972 14.1733 18.3957 13.0963C18.6942 12.0193 18.7509 10.8896 18.5619 9.78806C18.0135 6.54473 15.3069 3.95473 12.0402 3.55806C10.8918 3.41277 9.7253 3.53213 8.63008 3.907C7.53485 4.28187 6.5399 4.90232 5.72135 5.72086C4.9028 6.53941 4.28236 7.53437 3.90749 8.62959C3.53261 9.72481 3.41326 10.8913 3.55855 12.0397C3.95521 15.3064 6.54521 18.0131 9.78855 18.5614C10.8901 18.7505 12.0197 18.6937 13.0968 18.3952C14.1738 18.0967 15.1715 17.5638 16.0185 16.8347L16.3335 17.1614V18.0831L21.2919 23.0414C21.7702 23.5197 22.5519 23.5197 23.0302 23.0414C23.5085 22.5631 23.5085 21.7814 23.0302 21.3031L18.0835 16.3331ZM11.0835 16.3331C8.17855 16.3331 5.83355 13.9881 5.83355 11.0831C5.83355 8.17806 8.17855 5.83306 11.0835 5.83306C13.9885 5.83306 16.3335 8.17806 16.3335 11.0831C16.3335 13.9881 13.9885 16.3331 11.0835 16.3331Z"
                fill="#8D8D8D"
              />
            </svg>
          </div>
          {query.trim() !== "" && (
            <ClearIcon className="clear-icon" onClick={() => setQuery("")} />
          )}
        </div>

        <div style={{ display: "flex", gridGap: "20px" }}>
          <div className="selectParent select">
            <select
              className="custom-select"
              aria-label="Filter by user group"
              value={segmentType}
              onChange={(e) => {
                setSegment(e.target.value);
                handlePageChange({ selected: 1 });
              }}
            >
              <option value="">Filter by Status</option>
              {filter_by_role.map((item, index) => (
                <option key={index} value={item}>
                  {item}
                </option>
              ))}
            </select>
            <span className="focus"></span>
          </div>

          <div>
            <Button
              title="Reset all filters"
              style={{
                borderRadius: "6px",
                textTransform: "capitalize",
                fontSize: "16px",
                display: "flex",
                gridGap: "10px",
                alignContent: "center",
                alignItems: "center",
                background: "#0000a0",
                padding: "8px",
                color: "white",
                fontWeight: "600",
                width: "auto",
                height: "48px",
              }}
              className="submit_btn"
              onClick={reset}
            >
              <FaRedo />
            </Button>
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          paddingBottom: "1rem",
        }}
      >
        <div
          style={{
            display: "flex",
            gridGap: "10px",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              fontSize: "18px",
              paddingBottom: "1rem",
            }}
          >
            Total number of Recommendations{" "}
            <span
              style={{
                fontSize: "18px",
                fontWeight: "600",
                color: "#253978",
              }}
            >
              {search(filteredData).length}
            </span>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            gridGap: "10px",
            alignItems: "center",
            alignContent: "center",
          }}
        >
          <div>
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handelepageclick}
              containerClassName={"pagination"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
              forcePage={currentPage - 1}
            />
          </div>
        </div>
      </div>
      <div style={{ display: "grid" }}>
        {/* Header - Hidden on mobile */}
        <div
          style={{ background: "#1453A0", color: "white" }}
          className="hidden md:grid md:grid-cols-[3fr,3fr,3fr,2fr,2fr,1fr,1fr,1fr] gap-4 p-4 bg-gray-100 rounded-t-lg text-sm font-medium text-gray-600"
        >
         <div>Particulars</div>
          <div>KeyInsights</div>
          <div>Recommendations</div>
          <div>Value Creation</div>
          <div>Others</div>
          <div>Functions</div>
          <div>Status</div>
          <div></div>
        </div>

        <div style={{ display: "grid", gap: "1rem" }}>
          {currentData &&
            currentData.map((item, index) => (
              <div
                id={`id_${index}`}
                className="flex flex-col md:grid md:grid-cols-[3fr,3fr,3fr,2fr,2fr,1fr,1fr,1fr] gap-4 p-4 border-b border-gray-200 hover:bg-gray-50 bg-white rounded-lg shadow-sm"
              >
                {/* item Info Section */}
                <div className="flex flex-col  mt-4 sm:flex-row gap-4 md:flex-row">
                  <div className="flex-1">
                    <h5 className="font-medium text-gray-900">
                      {item.Particulars}
                    </h5>
                    <p className="text-sm text-gray-500">{item.ModuleName}</p>
                    <div className="mt-1">
                      <div className="flex flex-wrap items-center gap-2 text-sm text-gray-600">
                        <span>Segment: {item.segment || "N/A"}</span>
                      </div>

                      <div className="flex flex-wrap items-center gap-2 text-sm text-gray-600">
                        <span>Market: {item.segment || "N/A"}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Description Section */}
                <div className="pr-4 mt-4 md:mt-0">
                  <p className="text-sm text-gray-600">{item.KeyInsights}</p>
                  {/* <button className="text-blue-600 text-sm hover:underline mt-1">
                    More
                  </button> */}
                </div>

                {/* Average Stay */}
                {/* <div className="flex items-center gap-4 mt-2 md:mt-0">
                  <span className="md:hidden text-sm text-gray-600 w-32">
                    Average Stay:
                  </span>
               
                  <div className="progress-bar-container">
                    <div  title={`Avg day ${(item.AvgDaysAsPerTerms / 35) * 100}`} className="progress-bar">
                      <div
                        className="progress-fill"
                        title={`Avg day ${(item.AvgDaysAsPerTerms / 35) * 100}`}
                        style={{
                          width: `${(item.AvgDaysAsPerTerms / 35) * 100}%`,
                        }}
                      ></div>
                    </div>
                  </div>

                  <span className="text-sm text-gray-600">
                    {item.AvgDaysAsPerTerms}
                  </span>
                </div> */}

                <div className="pr-4 mt-4 md:mt-0">
                  <p className="text-sm text-gray-600">
                    {item.Recommendations}
                  </p>
                  {/* <button className="text-blue-600 text-sm hover:underline mt-1">
                    More
                  </button> */}
                </div>

                {/* Occupancy Rate and Stats */}
                <div className="mt-4 md:mt-0">
                  <div className="flex items-start gap-4">
                    {/* <CircularProgress percentage={((item.TotalValue/totalMargin)*100).toFixed(0) || 0} /> */}
                    <RadialBarChart valueItem={(item.TotalValue).toFixed(1)} percentage={((item.TotalValue/totalMargin)*100).toFixed(0) || 0}/>
               
                  </div>
                </div>

                <div className="mt-4 md:mt-0">
                  <div className="flex items-start gap-4">
                  
                    <div className="text-sm text-gray-600">
                      {item &&
                        item.OtherDetails &&
                        item.OtherDetails.length !== 0 &&
                        item.OtherDetails.map((detail, index) => (
                          <div key={index}>
                            {detail.name} : {detail.value}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>

                {/* Locations */}
                <div
                  style={{ display: "grid", alignContent: "baseline" }}
                  className="gap-1 mt-3"
                >
                    {item &&
                    item.Functions &&
                    item.Functions.map((detail, index) => (
                      <div key={index}>
                        <span
                          style={{
                            borderRadius: "7px",
                            background: "#eee",
                            color: "black",
                            paddingTop: "10px",
                            paddingBottom: "10px",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                          }}
                          className="inline-flex items-center text-xs font-medium bg-gray-100 text-gray-800"
                        >
                          {detail.name}
                        </span>
                      </div>
                    ))}
                </div>

                {/* Rating */}
                <div
                  className={`text-sm font-medium mt-4 md:mt-0 ${
                    item.Status === "To be reviewed"
                      ? "text-green-600"
                      : item.Status === "Action initiated"
                      ? "text-blue-600"
                      : "text-yellow-600"
                  }`}
                >
                  {item.Status}
                </div>

                <div className={`text-sm font-medium mt-5 md:mt-0`}>
                  {/* <Link to={`/dashboard?name=${item.CustomerName}`}>Act</Link> */}
                  <a
                    href={`/dashboard?name=${name}&&details=${details}&&particulars=${item.Particulars}&&node=${node}`}
                    style={{textDecoration:"underline"}}
                  >
                    Review
                  </a>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
